import FooterNav from '../../../router/footer-nav'
import {AuthService,PreviewService} from 'hasta-la-vista-middleware-api/service'

export default {
    name: 'site-footer',
    data () {
        return {
            items: FooterNav,
            isGuest: true,
            newsletter_email: '',
            subscribedDialog: false,
            loadingSubscribe:false,
            memberLevel: null,
            cardNumber: null,
            sb4for3: null,
            isSubs: false,
            isFanClub: false,
            isMorviesClub: false,
            PreviewService
        }
    },

    mounted() {
        AuthService.addObserver(this, AuthService.PROFILE_CHANGED, this.checkUser); // listen for changes to the user:
        this.checkUser(); // get and set the user.\
    },



    methods: {
        checkUser(){
            AuthService.user().then((user) => {
                if(user != undefined && user != null) {
                    this.sb4for3 = user.StandardBankBenefit
                    if(user.PreferenceList.includes(5) || user.PreferenceList.includes(6)) {
                        this.isSubs = true
                        if(user.PreferenceList.includes(5)) {
                            this.isMorviesClub = true
                        }

                        if(user.PreferenceList.includes(6)) {
                            this.isFanClub = true
                        }
                    }
                    this.memberLevel = user.MemberLevelId
                    this.cardNumber = user.CardNumber
                    this.isGuest = user.isGuest()
                }
            })
        },

        subscribe(email){
            this.loadingSubscribe = true
            AuthService.subscribeToNewsletter(email).then(()=> {
                this.subscribedDialog = true
                this.loadingSubscribe = false
            },()=>this.loadingSubscribe = false)
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/core/site-footer/site-footer.js